// UI-assets — MỘT dòng gọn khi lượt chạy Tài sản còn mục lỗi (thay hộp đỏ liệt kê khoá). Chữ thô của máy chủ chỉ ở Tooltip; nút «Chạy lại» dùng hành động có sẵn của đầu mục bước.
// Giữ id/testid `wf-step-flags` để nút «Xử lý N lỗi» của nút chính vẫn cuộn tới đây.
import React from 'react';
import { Tooltip } from 'antd';
import type { WorkflowStatus } from '../../types/filmWorkflow';
import type { PrimaryCall, SecondaryAction } from './workflowPrimaryPolicy';
import { assetsFailureLineOf } from './assetsFailureLine';
import WfIcon from './WfIcon';

interface Props {
  status: WorkflowStatus;
  actions: SecondaryAction[];
  sending: boolean;
  onRun: (call: PrimaryCall | null) => void;
}

const WorkflowAssetsFailureLine: React.FC<Props> = ({ status, actions, sending, onRun }) => {
  const line = assetsFailureLineOf(status, actions);
  if (!line) return null;
  const text = <span className="t" data-testid="wf-failline-text">{line.text}</span>;
  return (
    <p className="wf-failline" id="wf-step-flags" role="status" data-testid="wf-step-flags">
      <span className="wf-si bad"><WfIcon name="warning" /></span>
      {line.detail ? <Tooltip title={line.detail}>{text}</Tooltip> : text}
      {line.retry ? (
        <Tooltip title={!line.retry.enabled ? line.retry.reason : undefined}>
          <span className="wf-ib-w">
            <button type="button" className="wf-btn" disabled={!line.retry.enabled || sending} onClick={() => onRun(line.retry!.call)} data-testid="wf-failline-retry">Chạy lại</button>
          </span>
        </Tooltip>
      ) : null}
    </p>
  );
};

export default WorkflowAssetsFailureLine;
